import { FlexCell, FlexRow, Panel, VerticalTabButton } from '@epam/promo';
import { Outlet, useLocation } from 'react-router-dom';

import { useNavigationHandler } from 'hooks';
import { applicationSettingsRoutes } from 'router/applicationSettingsRoutes';
import { useMemo } from 'react';
import { useUserStore } from 'store/user';

interface SubMenuItem {
  caption: string;
  pathname: string;
}

const applicationSettingsSubMenu: SubMenuItem[] = [
  {
    caption: 'Functionality adjustment',
    pathname: applicationSettingsRoutes.functionalityAdjustment,
  },
  {
    caption: 'Personalization',
    pathname: applicationSettingsRoutes.personalization,
  },
  {
    caption: 'Broadcast tags',
    pathname: applicationSettingsRoutes.broadcastTags,
  },
];

export const ApplicationSettingsPage = () => {
  const location = useLocation();
  const handleNavigation = useNavigationHandler();
  const user = useUserStore((store) => store.user);

  const navigationTabs = useMemo(
    () =>
      applicationSettingsSubMenu.map(({ caption, pathname }) => (
        <VerticalTabButton
          key={caption}
          caption={caption}
          isActive={location.pathname === pathname}
          onClick={() => handleNavigation(pathname)}
        />
      )),
    [handleNavigation, location.pathname, user?.role],
  );

  return (
    <FlexRow
      columnGap="24"
      rawProps={{
        style: { margin: '1rem auto', marginRight: '24px', height: '100%' },
      }}>
      <Panel shadow style={{ alignSelf: 'start' }}>
        {navigationTabs}
      </Panel>
      <FlexCell grow={1} style={{ alignSelf: 'stretch' }}>
        <Panel shadow style={{ height: '100%' }}>
          <Outlet />
        </Panel>
      </FlexCell>
    </FlexRow>
  );
};
